import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = null as any;

const IsVisualGenericaEstudianteStateSlice = createSlice({
	name: 'isVisualGenericaEstudianteState',
	initialState,
	reducers: {
		setisVisualGenericaEstudianteState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		},
		resetisVisualGenericaEstudianteState: () => {
			return initialState;
		}
	}
});

export const { setisVisualGenericaEstudianteState, resetisVisualGenericaEstudianteState } =
	IsVisualGenericaEstudianteStateSlice.actions;

export default IsVisualGenericaEstudianteStateSlice.reducer;
